import { render } from "./TariffHero.vue?vue&type=template&id=8174d484&scoped=true"
const script = {}

import "./TariffHero.vue?vue&type=style&index=0&id=8174d484&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8174d484"]])

export default __exports__